import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignInComponent } from 'src/app/auth/sign-in/sign-in.component';
import { ForgotPasswordComponent } from 'src/app/auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from 'src/app/auth/change-password/change-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth-guard.guard'
import {AssetDetailComponent} from './assets/asset-detail/asset-detail.component';
import {AssetListComponent} from './assets/asset-list/asset-list.component';
import {DebtListComponent} from './debts/debt-list/debt-list.component';
import {DebtDetailComponent} from './debts/debt-detail/debt-detail.component';
import {ExploreNewPurchaseGuideComponent} from './guides/explore-new-purchase-guide/explore-new-purchase-guide.component';
import {BankAccountsListComponent} from './bank-accounts/bank-accounts-list/bank-accounts-list.component';
import {BankAccountDetailComponent} from './bank-accounts/bank-account-detail/bank-account-detail.component';
import {ProviderCredentialListComponent} from './bank-accounts/provider-credential-list/provider-credential-list.component';
import {ProviderCredentialAddUpdateComponent} from './bank-accounts/provider-credential-add-update/provider-credential-add-update.component';
import {EnrichmentRulesetListComponent} from './bank-accounts/enrichment-ruleset-list/enrichment-ruleset-list.component';
import {EnrichmentRuleAddUpdateComponent} from './bank-accounts/enrichment-rule-add-update/enrichment-rule-add-update.component';
import {EnrichmentRulesetListRulesComponent} from './bank-accounts/enrichment-ruleset-list-rules/enrichment-ruleset-list-rules.component';
import {AdminOverviewComponent} from './admin/admin-overview/admin-overview.component';

const routes: Routes = [
  { path: '', redirectTo: '/signin', pathMatch: 'full' },
  { path: 'signin', component: SignInComponent,},
  { path: 'forgot-password', component: ForgotPasswordComponent,},
  { path: 'change-password', component: ChangePasswordComponent,},
  { path: 'dashboard', component: DashboardComponent,canActivate: [AuthGuard]},
  { path: 'admin', component: AdminOverviewComponent, canActivate: [AuthGuard]},
  { path: 'assets', component: AssetListComponent, canActivate: [AuthGuard]},
  { path: 'assets/:assetId', component: AssetDetailComponent, canActivate: [AuthGuard]},
  { path: 'assets/create', component: AssetDetailComponent, canActivate: [AuthGuard]},
  { path: 'bank/accounts', component: BankAccountsListComponent, canActivate: [AuthGuard]},
  { path: 'bank/accounts/:accountId', component: BankAccountDetailComponent, canActivate: [AuthGuard]},
  { path: 'bank/accounts/enrichment/rulesets', component: EnrichmentRulesetListComponent, canActivate: [AuthGuard]},
  { path: 'bank/accounts/enrichment/rulesets/:rulesetId', component: EnrichmentRulesetListRulesComponent, canActivate: [AuthGuard]},
  { path: 'bank/accounts/enrichment/rulesets/:rulesetId/add', component: EnrichmentRuleAddUpdateComponent, canActivate: [AuthGuard]},
  { path: 'bank/accounts/enrichment/rulesets/:rulesetId/edit/:ruleNumber', component: EnrichmentRuleAddUpdateComponent, canActivate: [AuthGuard]},
  { path: 'bank/accounts/providers/credentials', component: ProviderCredentialListComponent, canActivate: [AuthGuard]},
  { path: 'bank/accounts/providers/credentials/add', component: ProviderCredentialAddUpdateComponent, canActivate: [AuthGuard]},
  { path: 'bank/accounts/providers/credentials/:credentialId', component: ProviderCredentialAddUpdateComponent, canActivate: [AuthGuard]},
  { path: 'debts', component: DebtListComponent, canActivate: [AuthGuard]},
  { path: 'debts/create', component: DebtDetailComponent, canActivate: [AuthGuard]},
  { path: 'debts/:debtId', component: DebtDetailComponent, canActivate: [AuthGuard]},
  { path: 'guides/purchase/new', component: ExploreNewPurchaseGuideComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthService]
})
export class AppRoutingModule { }
